import React from 'react';

import {colors} from 'js-libs/sweetcommons/styles';
import {Draggable, Droppable} from 'react-beautiful-dnd';
import styled from 'styled-components';

import {DraggableNavItem} from './DraggableNavItem';

import {AnnotatedNavLinkType, NUM_MAIN_LINKS} from '../nav_links';

interface Props {
  title: string;
  listId: string;
  navLinks: Array<AnnotatedNavLinkType>;
  main: boolean;
  dragEnabled: boolean;
}

export function DroppableNavList({
  title,
  listId,
  navLinks,
  main,
  dragEnabled,
}: Props): JSX.Element {
  function renderItem(
    navLink: AnnotatedNavLinkType,
    index: number,
    draggingOver: string | boolean | void
  ): JSX.Element {
    return (
      <DraggableNavItem
        homepage={main && index === 0}
        navLink={navLink}
        shortcutKey={(index + 1 + (main ? 0 : NUM_MAIN_LINKS)).toString()}
        secondary={draggingOver == null ? !main : draggingOver === 'more'}
      />
    );
  }

  return (
    <div>
      <StyledTitleDiv>{title}</StyledTitleDiv>
      {/* to avoid react-beautiful-dnd console errors we unmount its components
          before hiding the modal. See #7339 */}
      {dragEnabled ? (
        <Droppable droppableId={listId}>
          {(provided) => (
            <ol
              className="list-unstyled"
              {...provided.droppableProps}
              ref={provided.innerRef}
            >
              {navLinks.map((navLink, index) => (
                <Draggable
                  key={navLink.slug}
                  draggableId={navLink.slug}
                  index={index}
                >
                  {(provided, {draggingOver}) => (
                    <li
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      {...provided.dragHandleProps}
                    >
                      {renderItem(navLink, index, draggingOver)}
                    </li>
                  )}
                </Draggable>
              ))}
              {provided.placeholder}
            </ol>
          )}
        </Droppable>
      ) : (
        <ol className="list-unstyled">
          {navLinks.map((navLink, index) => (
            <li key={navLink.slug}>{renderItem(navLink, index, false)}</li>
          ))}
        </ol>
      )}
    </div>
  );
}

const StyledTitleDiv = styled.div`
  background: ${colors.lightBg};
  letter-spacing: -0.25pt;
  font-size: 80%;
  text-transform: uppercase;
  font-weight: bold;
  padding: 0.5rem 1.25rem;
  border-bottom: 1px solid rgba(0, 0, 0, 0.125);
`;
